export const DEPLOY__ENV = (data = {}) => {
  const isReg = /tst|uat|prd/g;
  let { origin } = location;
  let arr = origin.match(isReg) || [];
  let result = "";
  result = arr.length && arr[0] || 'prd';
  return data[result];
};

//尊享e生小程序 - H5部分业务 接口
export const websocketURL = DEPLOY__ENV({
  'tst': 'wss://nireus-tst.za-doctor.com',
  'uat': 'wss://nireus-uat.za-doctor.com',
  'prd': 'wss://nireus.za-doctor.com',
});


export const webviewURL = DEPLOY__ENV({
  'tst': 'https://online-tst.za-doctor.com',
  'uat': 'https://online-uat.za-doctor.com',
  'prd': 'https://online.za-doctor.com',
});

export const zaappEnv = DEPLOY__ENV({
  'tst': '2',
  'uat': '2',
  'prd': '0'
})

export const appletVersion = DEPLOY__ENV({
  'tst': 'trial',
  'uat': 'trial',
  'prd': 'release'
})

export const useChannelSource = DEPLOY__ENV({
  'tst': 'CSN13500106',
  'uat': 'CSN02000105',
  'prd': 'CSN07000487'
})

export const moneyLink = DEPLOY__ENV({
  'tst': 'https://a-test1.zhongan.com/gp/83548305',
  'uat': 'https://m-uat.zhongan.com/gp/83548305',
  'prd': 'https://m.zhongan.com/gp/83548305'
})

export const activityId = DEPLOY__ENV({
  'tst': 370004,
  'uat': 145002,
  'prd': 150002,
});

export const gjCoMarketingDetailUrl = (itemId) => {
  return DEPLOY__ENV({
    'tst': 'https://mobile-test.gaojihealth.cn/healthb2czha/modules/o2o/productDetail/dispatch?channelId=8a5e8c5d&itemId=5281290211420001&owner=aprilCoMarketing',
    'uat': 'https://mobile-test.gaojihealth.cn/healthb2czha/modules/o2o/productDetail/dispatch?channelId=8a5e8c5d&itemId=5281290211420001&owner=aprilCoMarketing',
    'prd': `https://mobile.gaojihealth.cn/healthb2czha/modules/o2o/productDetail/dispatch?channelId=8a5e8c5d&owner=aprilCoMarketing&itemId=${itemId}`,
  })
};

export const gjCoMarketingListlUrl = DEPLOY__ENV({
  'tst': 'https://mobile-test.gaojihealth.cn/healthb2czha/modules/orderList/index?channelId=8a5e8c5d&owner=aprilCoMarketing',
  'uat': 'https://mobile-test.gaojihealth.cn/healthb2czha/modules/orderList/index?channelId=8a5e8c5d&owner=aprilCoMarketing',
  'prd': 'https://mobile.gaojihealth.cn/healthb2czha/modules/orderList/index?channelId=8a5e8c5d&owner=aprilCoMarketing'
});

export const getMJURL = DEPLOY__ENV({
  'tst': 'https://ssr-qa.doctorwork.com',
  'uat': 'https://ssr-qa.doctorwork.com',
  'prd': 'https://ssr.doctorwork.com'
});

export const getEnv = () => {
  if (window.location.href.indexOf('localhost') !== -1) {
    return 'dev'
  }
  if (window.location.href.indexOf('127.0.0.1') !== -1) {
    return 'dev'
  }
  if (window.location.href.indexOf('dev') !== -1) {
    return 'dev'
  }
  if (window.location.href.indexOf('test') !== -1) {
    return 'test'
  }
  if (window.location.href.indexOf('tst') !== -1) {
    return 'test'
  }
  if (window.location.href.indexOf('pre') !== -1) {
    return 'pre'
  }
  if (window.location.href.indexOf('uat') !== -1) {
    return 'pre'
  }
  return 'prd'
}

export const getZAMallHostname = () => {
  if(getEnv() === 'test'){
    return 'https://mall-test.zhonganbio.com';
  }
  if(getEnv() === 'pre'){
    return 'https://mall-uat.zhonganbio.com';
  }
  if(getEnv() === 'prd'){
    return 'https://mall.zhonganbio.com';
  }
  return 'https://mall-test.zhonganbio.com';
}

export const getZAHAOYAOSHIHostname = () => {
  if(getEnv() === 'test'){
    return 'https://mall-test.zadrugstore.com';
  }
  if(getEnv() === 'pre'){
    return 'https://mall-uat.zadrugstore.com';
  }
  if(getEnv() === 'prd'){
    return 'https://mall.zadrugstore.com';
  }
  return 'https://mall-test.zadrugstore.com';
}

export const getZAHealthHostname = () => {
  if(getEnv() === 'test'){
    return 'https://ihealth-test.zhongan.com';
  }
  if(getEnv() === 'pre'){
    return 'https://ihealth-uat.zhongan.com';
  }
  if(getEnv() === 'prd'){
    return 'https://ihealth.zhongan.com';
  }
  return 'https://ihealth.zhongan.com';
}

/**
 * @description 互医商城域名
 * @returns 
 */
export const getHyMallHostname = () => {
  if(getEnv() === 'test'){
    return 'https://mall-test.za-doctor.com';
  }
  if(getEnv() === 'pre'){
    return 'https://mall-uat.za-doctor.com';
  }
  if(getEnv() === 'prd'){
    return 'https://mall.za-doctor.com';
  }
  return 'https://mall.za-doctor.com';
}

export const isHospitalHostname = (hostname) => {
  if(hostname === window.location.hostname){
    return true;
  }
  if(hostname === 'online-tst.za-doctor.com' && window.location.hostname === 'localhost'){
    return true;
  }
  return false
}

